import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useCreateOTRuleMutation } from "../api/queries";
import { OTRuleForm } from "../ui/OTRuleForm";
import type { CreateOTRuleDTO } from "@/modules/hr/overtime/domain/types";
import { Button, toast } from "@devhop/ui";
import { ArrowLeft, HelpCircle } from "lucide-react";
import { OTRuleCreateTour, useOTRuleCreateTour } from "../tour/OTRuleCreateTour";

const RULES_LIST_SEARCH = {
  offset: 0,
  limit: 20,
  dayType: undefined as "weekday" | "holiday" | undefined,
  isActive: undefined as boolean | undefined,
  search: undefined as string | undefined,
};

export function OTRuleCreatePage() {
  const nav = useNavigate();
  const createMutation = useCreateOTRuleMutation();
  const tour = useOTRuleCreateTour();

  const handleBack = () => {
    nav({ to: "/app/hr/overtime/rules", search: RULES_LIST_SEARCH });
  };

  const handleSubmit = (values: CreateOTRuleDTO) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        toast.success("ສ້າງຂໍ້ກຳນົດ OT ສຳເລັດ");
        nav({ to: "/app/hr/overtime/rules", search: RULES_LIST_SEARCH });
      },
      onError: (err) => {
        toast.error(err?.message ?? "ເກີດຂໍ້ຜິດພາດ");
      },
    });
  };

  return (
    <>
      <Header />
      <Main>
        <OTRuleCreateTour run={tour.run} onCallback={tour.handleJoyrideCallback} />
        <div className="mb-6 flex items-center justify-between gap-2" data-tourid="ot-rule-create-back">
          <div>
            <div className="flex items-center gap-2">
              <h1 className="font-semibold text-2xl">ສ້າງຂໍ້ກຳນົດ OT</h1>
              <Button
                variant="ghost"
                size="icon"
                className="size-7 rounded-full"
                onClick={tour.startTour}
                title="ເລີ່ມທົດສອບການນຳທາງ"
                aria-label="ເລີ່ມທົດສອບການນຳທາງ"
              >
                <HelpCircle className="size-5" />
              </Button>
            </div>
            <p className="text-muted-foreground text-sm">
              ສ້າງຂໍ້ກຳນົດອັດຕາຄູນ OT ໃໝ່
            </p>
          </div>
          <Button variant="ghost" size="sm" onClick={handleBack} className="gap-2">
            <ArrowLeft className="h-4 w-4" />
            ກັບໄປລາຍການ
          </Button>
        </div>

        <div className="mx-auto w-full max-w-4xl space-y-6" data-tourid="ot-rule-create-form">
          <OTRuleForm
            mode="create"
            onSubmit={handleSubmit}
            onCancel={handleBack}
            isSubmitting={createMutation.isPending}
          />
        </div>
      </Main>
    </>
  );
}
